"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteMapRestData = exports.SiteDataActionType = void 0;
var RestData_1 = require("./RestData");
var urls_1 = require("../urls");
var SiteDataActionType;
(function (SiteDataActionType) {
    SiteDataActionType["MAP_CHANGED"] = "MAP_CHANGED";
})(SiteDataActionType = exports.SiteDataActionType || (exports.SiteDataActionType = {}));
function useSiteMapRestData(base_url, dispatch, success, fail) {
    var rest = (0, RestData_1.useRestData)(base_url, dispatch, success, fail);
    function set_map(content, object_id) {
        var url = (0, urls_1.trailing_slash)(base_url) +
            object_id +
            "/" +
            urls_1.Urls.admin_site_maps_set_map_suffix;
        var formData = new FormData();
        formData.append("map", content);
        rest._make_request(url, {
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
        }, SiteDataActionType.MAP_CHANGED, object_id);
    }
    return {
        list: rest.list,
        create: rest.create,
        update: rest.update,
        remove: rest.remove,
        set_map: set_map,
    };
}
exports.useSiteMapRestData = useSiteMapRestData;
